export default __webpack_public_path__ + "static/media/img-profile.eca4bf0f.png";